import type { CreateSizingExperimentDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export default function useCreateSizingExperiment(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation("post", "/shops/{shopId}/sizing/experiments", {
		invalidate: () => {
			queryClient.invalidateQueries({
				queryKey: ["get", "/shops/{shopId}/sizing/experiments"],
			});
		},
		mapVariables: (body: CreateSizingExperimentDto) => ({
			params: { path: { shopId } },
			body,
		}),
	});
}
